export default __webpack_public_path__ + "static/media/slot-banners-ms.ba55f357.webp";